import * as React from "react";
import { Page, PageHero, Tabs } from "src/components/common";

interface IProps {
	children?: any;
	match?: any;
	location?: any;
}

const ReportsTabs: React.FC<IProps> = (props) => {
	const tabs = [
		{
			id: 1,
			to: "/admin/reports",
			label: "Reports",
		},
	];

	return (
		<React.Fragment>
			<Page>
				<PageHero className="no-print">
					<h1>Reports</h1>
				</PageHero>
				<Tabs className="mb-4 no-print" tabs={tabs} location={props.location} />
				{props.children}
			</Page>
		</React.Fragment>
	);
};

export default ReportsTabs;
